var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2746 7.02805C11.9085 7.44647 11.9085 8.12486 12.2746 8.54328L16.2992 13.1428L12.2746 17.7423C11.9085 18.1608 11.9085 18.8391 12.2746 19.2576C12.6407 19.676 13.2343 19.676 13.6004 19.2576L18.2879 13.9004C18.654 13.482 18.654 12.8036 18.2879 12.3852L13.6004 7.02805C13.2343 6.60963 12.6407 6.60963 12.2746 7.02805Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71209 7.02805C5.34597 7.44647 5.34597 8.12486 5.71209 8.54328L9.73668 13.1428L5.71209 17.7423C5.34597 18.1608 5.34597 18.8391 5.71209 19.2576C6.0782 19.676 6.6718 19.676 7.03791 19.2576L11.7254 13.9004C12.0915 13.482 12.0915 12.8036 11.7254 12.3852L7.03791 7.02805C6.6718 6.60963 6.0782 6.60963 5.71209 7.02805Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsRight);
export default __webpack_public_path__ + "static/media/chevrons-right.e6e5d60a0c83a79dc8a4d4a4b953dea7.svg";
export { ForwardRef as ReactComponent };